module.exports = __webpack_public_path__ + "static/media/alchemix.edc7890b.png";